import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom';
// @ts-ignore
import Logo from '../../resources/dptl-logo-full.png';
import '../../scss/login.scss';
import TextField from '@mui/material/TextField';
import { L } from 'harmony-language';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import { LoginResult, LoginStatus, userSignIn } from './actions/user-sign-in';
import { ModalDialog } from '../shared/containers/modal-dialog';
import { OtpSetupVerify } from './otp-setup-verify';

export const LoginForm = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isSigningIn, setIsSigningIn] = useState(false);
    const [otpResult, setOtpResult] = useState<LoginResult | null>(null);

    const handleUsernameInput = (e: React.ChangeEvent<HTMLInputElement>) => setUsername(e.target.value);
    const handlePasswordInput = (e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value);
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        setIsSigningIn(true);
        e.preventDefault();

        const loginResult = await userSignIn(username, password);
        if (loginResult.status === LoginStatus.OTP) {
            setOtpResult(loginResult);
        } else if (loginResult.status === LoginStatus.Success) {
            navigate('/');
        }

        setIsSigningIn(false);
    };

    return (
        <div className='login-container'>
            <Paper className='login-paper'>
                <img className='agistics-logo' src={Logo} alt='' />
                <form className='login-form' onSubmit={(e) => handleSubmit(e)}>
                    <TextField
                        variant='standard'
                        id='username'
                        type='text'
                        label={L.username()}
                        InputLabelProps={{ shrink: true }}
                        value={username}
                        onChange={handleUsernameInput} />
                    <TextField
                        variant='standard'
                        id='password'
                        type='password'
                        label={L.password()}
                        InputLabelProps={{ shrink: true }}
                        value={password}
                        onChange={handlePasswordInput} />
                    <Button type='submit'
                        variant='contained'
                        color='primary'
                        disabled={isSigningIn}
                    >
                        {isSigningIn ? <CircularProgress size={24}/> : L.login()}
                    </Button>
                </form>
                <Link to='/forgot-password'>{L.forgotPassword()}</Link>
            </Paper>
            <ModalDialog
                title='OTP'
                onClose={() => setOtpResult(null)}
                open={Boolean(otpResult)}
            >
                {otpResult && <OtpSetupVerify
                    otpResult={otpResult}
                    username={username}
                    password={password}
                    tokenSuccess={() => {
                        setOtpResult(null);
                        navigate('/');
                    }}
                />}
            </ModalDialog>
        </div>
    );
};
